module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myo-paramters"
  }, [(_vm.type == 'beachflag') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Form")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "shape",
      "id": "shape"
    },
    model: {
      value: (_vm.parameters.shape),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "shape", $$v)
      },
      expression: "parameters.shape"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "normal"
    }
  }, [_vm._v("Normal")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "drop"
    }
  }, [_vm._v("Dråpe")])], 1)], 1), _vm._v(" "), (_vm.parameters.shape === 'normal') ? _c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "size"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "small"
    }
  }, [_vm._v("Small (220 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "medium"
    }
  }, [_vm._v("Medium (265 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "large"
    }
  }, [_vm._v("Large (365 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "xl"
    }
  }, [_vm._v("XL (420 cm)")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.parameters.shape === 'drop') ? _c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "size"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "small"
    }
  }, [_vm._v("Small (181 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "medium"
    }
  }, [_vm._v("Medium (208 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "large"
    }
  }, [_vm._v("Large (271 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "xl"
    }
  }, [_vm._v("XL (372 cm)")])], 1)], 1) : _vm._e()], 1) : (_vm.type == 'banner') ? _c('div', [(_vm.parameters.features) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Materiale")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.features.material),
      callback: function($$v) {
        _vm.$set(_vm.parameters.features, "material", $$v)
      },
      expression: "parameters.features.material"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "pvc"
    }
  }, [_vm._v("PVC")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "textile"
    }
  }, [_vm._v("Tekstil")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Bredde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.width),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "width", $$v)
      },
      expression: "parameters.width"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Høyde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.height),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "height", $$v)
      },
      expression: "parameters.height"
    }
  })], 1), _vm._v(" "), (_vm.parameters.extra) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Maljer/hull")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.holes),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "holes", $$v)
      },
      expression: "parameters.extra.holes"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1), _vm._v(" "), (_vm.parameters.extra.holes) ? _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Antall strikker (beregnes automatisk)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number",
      "disabled": true
    },
    model: {
      value: (_vm.parameters.extra.rubber_bands),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "rubber_bands", $$v)
      },
      expression: "parameters.extra.rubber_bands"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : (_vm.type == 'flex-wall') ? _c('div', [(_vm.parameters.features) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Trykk duk")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.features.sides),
      callback: function($$v) {
        _vm.$set(_vm.parameters.features, "sides", $$v)
      },
      expression: "parameters.features.sides"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "single"
    }
  }, [_vm._v("En-sidig trykk")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "double"
    }
  }, [_vm._v("To-sidig trykk")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.parameters.extra) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Med system")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.system),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "system", $$v)
      },
      expression: "parameters.extra.system"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Bredde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.width),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "width", $$v)
      },
      expression: "parameters.width"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Høyde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.height),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "height", $$v)
      },
      expression: "parameters.height"
    }
  })], 1)], 1) : (_vm.type == 'curved-pop-up-wall') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Vegg")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.type),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "type", $$v)
      },
      expression: "parameters.type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "curved"
    }
  }, [_vm._v("POP-up vegg 225x350 cm")])], 1)], 1)], 1) : (_vm.type == 'expo-tent') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Vegg")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.type),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "type", $$v)
      },
      expression: "parameters.type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "300x300"
    }
  }, [_vm._v("EXPO-telt 300x300 cm")])], 1)], 1)], 1) : (_vm.type == 'digital-booklet') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Antall sider")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.pages),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "pages", $$v)
      },
      expression: "parameters.pages"
    }
  })], 1)], 1) : (_vm.type == 'alu-frame') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "size"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "A4"
    }
  }, [_vm._v("A4")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A3"
    }
  }, [_vm._v("A3")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A2"
    }
  }, [_vm._v("A2")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A1"
    }
  }, [_vm._v("A1")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "50x50"
    }
  }, [_vm._v("50x50 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "60x60"
    }
  }, [_vm._v("60x60 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "60x80"
    }
  }, [_vm._v("60x80 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "70x100"
    }
  }, [_vm._v("70x100 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "100x150"
    }
  }, [_vm._v("100x150 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "100x200"
    }
  }, [_vm._v("100x200 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "300x300"
    }
  }, [_vm._v("300x300 cm")])], 1)], 1)], 1) : (_vm.type == 'l-banner') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "type"
    },
    model: {
      value: (_vm.parameters.type),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "type", $$v)
      },
      expression: "parameters.type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "single-75x200"
    }
  }, [_vm._v("Enkel 75x200 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "single-90x200"
    }
  }, [_vm._v("Enkel 90x200 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "double-90x200"
    }
  }, [_vm._v("Dobbel 90x200 cm")])], 1)], 1)], 1) : (_vm.type == 'l-banner-graphics') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "type"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "75x200"
    }
  }, [_vm._v("75x200 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "90x200"
    }
  }, [_vm._v("90x200 cm")])], 1)], 1)], 1) : (_vm.type == 'x-banner') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "type"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "80x180"
    }
  }, [_vm._v("80x180 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "90x210"
    }
  }, [_vm._v("90x210 cm")])], 1)], 1)], 1) : (_vm.type == 'x-banner-graphics') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "type"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "80x180"
    }
  }, [_vm._v("80x180 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "90x210"
    }
  }, [_vm._v("90x210 cm")])], 1)], 1)], 1) : (_vm.type == 'canvas') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "A4"
    }
  }, [_vm._v("A4")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A3"
    }
  }, [_vm._v("A3")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A2"
    }
  }, [_vm._v("A2")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A1"
    }
  }, [_vm._v("A1")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "50x50"
    }
  }, [_vm._v("50x50")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "60x60"
    }
  }, [_vm._v("60x60")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "70x100"
    }
  }, [_vm._v("70x100")])], 1)], 1)], 1) : (_vm.type == 'alu-plate') ? _c('div', [(_vm.parameters.features) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Tykkelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.features.thickness),
      callback: function($$v) {
        _vm.$set(_vm.parameters.features, "thickness", $$v)
      },
      expression: "parameters.features.thickness"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 mm")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Bredde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.width),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "width", $$v)
      },
      expression: "parameters.width"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Høyde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.height),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "height", $$v)
      },
      expression: "parameters.height"
    }
  })], 1), _vm._v(" "), (_vm.parameters.extra) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Formskjæring")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.cut_to_shape),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "cut_to_shape", $$v)
      },
      expression: "parameters.extra.cut_to_shape"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Hulling")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.holes),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "holes", $$v)
      },
      expression: "parameters.extra.holes"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1)], 1) : _vm._e()], 1) : (_vm.type == 'pvc-plate') ? _c('div', [(_vm.parameters.features) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Tykkelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.features.thickness),
      callback: function($$v) {
        _vm.$set(_vm.parameters.features, "thickness", $$v)
      },
      expression: "parameters.features.thickness"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 mm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 mm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 mm")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Bredde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.width),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "width", $$v)
      },
      expression: "parameters.width"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Høyde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.height),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "height", $$v)
      },
      expression: "parameters.height"
    }
  })], 1), _vm._v(" "), (_vm.parameters.extra) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Hulling")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.holes),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "holes", $$v)
      },
      expression: "parameters.extra.holes"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Formskjæring")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.cut_to_shape),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "cut_to_shape", $$v)
      },
      expression: "parameters.extra.cut_to_shape"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1)], 1) : _vm._e()], 1) : _c('div', [_c('div', {
    staticClass: "p2 rounded bg-light-grey"
  }, [_vm._v("\n      Dette produktet trenger ikke å tilpasses.\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ee8be9d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/myo/Parameters.vue
// module id = 643
// module chunks = 1